/* Rovina native offers: quantity bars (one-time purchase) for the Dawn product form. */
if (!customElements.get('clone-offers')) {
  customElements.define(
    'clone-offers',
    class CloneOffers extends HTMLElement {
      connectedCallback() {
        try {
          this.data = JSON.parse(this.querySelector('[data-offers-json]').textContent);
        } catch (e) {
          return;
        }
        this.sectionId = this.dataset.section;
        this.qtyInput = this.querySelector('[data-offers-quantity]');
        this.bars = Array.from(this.querySelectorAll('[data-offers-bar]'));
        this.variantId = Number(document.querySelector(`#product-form-${this.sectionId} input[name="id"]`)?.value) || this.data.variants[0]?.id;

        this.bars.forEach((bar) =>
          bar.querySelector('input').addEventListener('change', () => this.selectBar(bar))
        );

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId || !event.data.variant) return;
            this.variantId = event.data.variant.id;
            // Dawn has just replaced the price block from the server: re-apply ours afterwards.
            setTimeout(() => this.render(), 0);
          });
        }
        this.render();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      get variant() {
        return this.data.variants.find((v) => v.id === this.variantId) || this.data.variants[0];
      }

      selectBar(bar) {
        this.bars.forEach((b) => b.classList.toggle('is-selected', b === bar));
        this.qtyInput.value = bar.dataset.quantity;
        this.render();
      }

      money(cents) {
        const fmt = this.data.moneyFormat || '${{amount}}';
        const value = (Math.round(cents) / 100).toFixed(2);
        const [int, dec] = value.split('.');
        const withSep = (sep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
          switch (key) {
            case 'amount_no_decimals':
              return withSep(',');
            case 'amount_with_comma_separator':
              return `${withSep('.')},${dec}`;
            case 'amount_no_decimals_with_comma_separator':
              return withSep('.');
            default:
              return `${withSep(',')}.${dec}`;
          }
        });
      }

      render() {
        const v = this.variant;
        if (!v) return;
        const { price, compare } = v;

        this.bars.forEach((bar) => {
          const qty = Number(bar.dataset.quantity) || 1;
          const discount = Number(bar.dataset.discount) || 0;
          const total = Math.round(price * qty * (100 - discount) / 100);
          const full = compare * qty;
          bar.querySelector('[data-bar-price]').textContent = this.money(total);
          const cmp = bar.querySelector('[data-bar-compare]');
          cmp.textContent = this.money(full);
          cmp.classList.toggle('hidden', full <= total);
          const sub = bar.querySelector('.clone-offers__bar-subtitle[data-template]');
          if (sub) sub.textContent = sub.dataset.template.replace('[saved]', `${Math.max(0, Math.round((1 - total / full) * 100))}%`);
        });

        this.updateMainPrice(price, compare);
        this.updateButton();
      }

      updateMainPrice(price, compare) {
        const box = document.getElementById(`price-${this.sectionId}`);
        if (!box) return;
        const onSale = compare > price;
        box.innerHTML = `<div class="price price--large${onSale ? ' price--on-sale' : ''}">
          <div class="price__container"><div class="price__sale" style="display:flex;gap:1rem;align-items:baseline">
            <span class="price-item price-item--sale price-item--last">${this.money(price)}</span>
            ${onSale ? `<s class="price-item price-item--regular">${this.money(compare)}</s>` : ''}
          </div></div></div>`;
      }

      updateButton() {
        const qty = Number(this.qtyInput.value) || 1;
        document.dispatchEvent(new CustomEvent('clone-offers:change', { detail: { sectionId: this.sectionId, quantity: qty } }));
      }
    }
  );
}
